import { useAuth } from '../../auth/AuthContext';
import { Badge, Card } from '../../components/ui';
import { EmployeesPage } from './EmployeesPage';
import { ServicesSection } from './ServicesSection';
import { AuditSection } from './AuditSection';

export function SettingsPage() {
  const { branches, branchFilter } = useAuth();

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">Settings</h1>
        <p className="mt-1 text-sm text-slate-500">
          Accounts, branches and configuration. Changes here are audit-logged.
        </p>
      </header>

      {/* Sidebar anchor: System Settings → User and Roles */}
      <div id="employees" className="scroll-mt-24">
        <EmployeesPage />
      </div>

      <ServicesSection />

      <section aria-label="Branches" className="space-y-3">
        <h2 className="text-xl font-bold tracking-tight text-slate-900">Branches</h2>
        <div className="grid grid-cols-2 gap-3">
          {branches.map((b) => (
            <Card key={b.id} className="flex items-center gap-3 p-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-100 text-sm font-bold text-slate-600">
                {b.code}
              </span>
              <div className="min-w-0">
                <p className="truncate font-semibold text-slate-900">{b.name}</p>
                <p className="text-xs text-slate-500">
                  {b.isActive ? 'Active' : 'Inactive'}
                  {branchFilter === b.code ? ' · currently filtered' : ''}
                </p>
              </div>
              <Badge tone="indigo" className="ml-auto">
                Foundation
              </Badge>
            </Card>
          ))}
        </div>
        <p className="text-sm text-slate-500">
          Branches power everything: numbering (LH1-000001), pricing, inventory and reports are all
          branch-scoped.
        </p>
      </section>

      {/* Sidebar anchor: System Settings → Audit Log */}
      <AuditSection />
    </div>
  );
}
